/**
 * How the UI recognises a repair refusal (ACT2-1286). Pure: no React, so a lib like `panel-error`
 * can use it too.
 */
import { ACCOUNT_NEEDS_REPAIR_REASON, type ProbeVerdict } from '@server/warehouse-repair';

import { hasOrpcCode } from '@/_shared/lib/orpc-errors';

function reasonOf(err: unknown): unknown {
  if (!err || typeof err !== 'object') return undefined;
  const data = (err as { data?: unknown }).data;
  return data && typeof data === 'object' ? (data as { reason?: unknown }).reason : undefined;
}

/** `PRECONDITION_FAILED` with `data.reason = 'account_needs_repair'`: the one needs-repair refusal. */
export function isAccountNeedsRepairError(err: unknown): boolean {
  return hasOrpcCode(err, 'PRECONDITION_FAILED') && reasonOf(err) === ACCOUNT_NEEDS_REPAIR_REASON;
}

/** A lost compare-and-set: someone else repaired the item since the dialog opened. */
export function isRepairConflictError(err: unknown): boolean {
  return hasOrpcCode(err, 'CONFLICT') && reasonOf(err) === 'repair_conflict';
}

/** The probe verdict a needs-repair refusal carries (confirm on a failed account, Resume). */
export function refusalVerdict(err: unknown): ProbeVerdict | null {
  if (!err || typeof err !== 'object') return null;
  const data = (err as { data?: unknown }).data;
  const verdict = data && typeof data === 'object' ? (data as { verdict?: unknown }).verdict : undefined;
  return verdict && typeof verdict === 'object' && 'result' in verdict ? (verdict as ProbeVerdict) : null;
}
